
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { tripModule, waypointModule } from '@/store'
import { Location, Waypoint } from '@/types/trip'
import {
  distanceBetweenCoordinates,
  formattedDistance,
} from '@/utils/utility-manager'
import {
  LocalTripSettings,
  useLocalTripSettings,
} from '@/composables/trip-settings'

interface WaypointDistance {
  _id: string
  name: string
  distance?: number
}

@Component({
  name: 'WaypointList',
  setup() {
    const { tripSettings } = useLocalTripSettings(tripModule.trip!.id)

    return { tripSettings }
  },
})
class WaypointList extends Vue {
  @Prop({ default: false, type: Boolean })
  readonly showCurrentWaypoint?: boolean

  @Prop({ default: false, type: Boolean }) readonly showDistance!: boolean
  @Prop() readonly location?: Location

  waypoints: Waypoint[] = this.trip.waypoints
  waypointDistances: WaypointDistance[] = []
  timestamp: number = new Date().getTime()
  tripSettings!: LocalTripSettings

  get trip() {
    return tripModule.trip!
  }

  get currentWaypoint(): Waypoint | null {
    return waypointModule.waypoint
  }

  get sortedWaypoints() {
    if (this.showDistance && this.location) {
      return this.waypointDistances
    }
    return this.waypoints.map((waypoint) => ({
      _id: waypoint._id,
      name: waypoint.name,
      distance: undefined,
    }))
  }

  @Watch('location')
  calculateDistances() {
    if (!this.location || !this.showDistance) {
      return
    }

    this.waypointDistances = this.trip.waypoints
      .map((waypoint) => ({
        _id: waypoint._id,
        name: waypoint.name,
        distance: distanceBetweenCoordinates(waypoint.location, {
          latitude: this.location?.latitude!,
          longitude: this.location?.longitude!,
        }),
      }))
      .sort((a, b) => a.distance - b.distance)
  }

  mounted() {
    this.calculateDistances()
  }

  formattedDistance(distance: number): string {
    return formattedDistance(distance, this.tripSettings.distanceUnit)
  }

  hideCurrentWaypoint(waypointId: string): boolean {
    if (this.currentWaypoint) {
      if (
        waypointId === this.currentWaypoint?._id &&
        !this.showCurrentWaypoint
      ) {
        return true
      }
    }
    return false
  }
}
export default WaypointList
